import Typography from '@mui/material/Typography';
import { Box, Stack } from '@mui/system';
import { palette } from '@openx/components-core/lib/theme/paletteV2.ts';
import { useTranslation } from 'react-i18next';
import { DIRECT_DEALS_LIST_VIEW, type DirectDealsListView } from '../utils/context/types.ts';
import { type FilterPresetTabConfig, FilterPresetTabs } from './parts/FilterPresetTabs.tsx';
import { ViewIconButton } from './parts/ViewIconButton.tsx';

type DirectDealsHeaderProps = {
  onViewTypeChange: (type: DirectDealsListView) => void;
  currentViewType: DirectDealsListView;
};

export const DirectDealsHeader = ({ currentViewType, onViewTypeChange }: DirectDealsHeaderProps) => {
  const { t } = useTranslation();

  const tabs: FilterPresetTabConfig[] = [
    {
      name: 'all',
      label: t('All'),
    },
    {
      name: 'featured',
      label: t('Featured'),
      isDefault: true,
    },
    {
      name: 'tv_by_openx',
      label: t('TV by OpenX'),
    },
  ];

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        backgroundColor: palette.background.boxDark,
        color: palette.text.secondary,
      }}
    >
      <Box sx={{ flex: 1 }}>
        <FilterPresetTabs tabs={tabs} />
      </Box>
      <Stack
        direction="row"
        sx={{
          justifySelf: 'flex-end',
          backgroundColor: palette.background.boxDark,
          padding: theme => theme.spacing(1, 1, 1, 4),
          color: palette.text.secondary,
        }}
      >
        <Typography component="span">{t('View by:')}</Typography>

        <ViewIconButton
          currentViewType={currentViewType}
          viewType={DIRECT_DEALS_LIST_VIEW.TILE}
          onViewTypeChange={onViewTypeChange}
        />

        <ViewIconButton
          currentViewType={currentViewType}
          viewType={DIRECT_DEALS_LIST_VIEW.TABULAR}
          onViewTypeChange={onViewTypeChange}
        />
      </Stack>
    </Stack>
  );
};
